import { registerComponent } from "helpers";

registerComponent(
  "peanuts-pdp",
  class PeanutsPdp extends HTMLElement {
    connectedCallback() {
      this.animation = this.querySelector(".peanuts-animation");
      this.primary = this.parentElement;

      if (!this.primary || !this.animation) return;

      this.boundMouseEnter = this.onMouseEnter.bind(this);
      this.boundMouseLeave = this.onMouseLeave.bind(this);
      this.boundMouseMove = this.onMouseMove.bind(this);
      this.boundBreakpointChange = this.onBreakpointChange.bind(this);

      this.mq = window.matchMedia("(min-width: 1024px)");
      this.mq.addEventListener("change", this.boundBreakpointChange);
      this.onBreakpointChange(this.mq);
    }

    disconnectedCallback() {
      this.mq?.removeEventListener("change", this.boundBreakpointChange);
      this.disableDesktop();
    }

    onBreakpointChange(event) {
      if (event.matches) {
        this.enableDesktop();
      } else {
        this.disableDesktop();
      }
    }

    enableDesktop() {
      if (this.desktopEnabled) return;
      this.desktopEnabled = true;

      this.primary.addEventListener("mouseenter", this.boundMouseEnter);
      this.primary.addEventListener("mouseleave", this.boundMouseLeave);
      this.primary.addEventListener("mousemove", this.boundMouseMove);

      if (this.primary.matches(":hover")) this.onMouseEnter();
    }

    disableDesktop() {
      this.cancelPendingFrame();
      this.animation?.classList.remove("peanuts-animation--visible");

      if (!this.desktopEnabled) return;
      this.desktopEnabled = false;

      this.primary.removeEventListener("mouseenter", this.boundMouseEnter);
      this.primary.removeEventListener("mouseleave", this.boundMouseLeave);
      this.primary.removeEventListener("mousemove", this.boundMouseMove);
    }

    cancelPendingFrame() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
      this.rafPending = false;
    }

    onMouseEnter() {
      this.animation.classList.add("peanuts-animation--visible");
    }

    onMouseLeave() {
      this.cancelPendingFrame();
      this.animation.classList.remove("peanuts-animation--visible");
    }

    onMouseMove(event) {
      this.mouseX = event.clientX;
      this.mouseY = event.clientY;

      if (this.rafPending) return;
      this.rafPending = true;

      this.rafId = requestAnimationFrame(() => {
        const rect = this.primary.getBoundingClientRect();
        // Offset so .peanuts-cursor (top: -20px, left: -14px) lands at the pointer
        this.animation.style.setProperty(
          "--peanuts-x",
          `${this.mouseX - rect.left + 14}px`,
        );
        this.animation.style.setProperty(
          "--peanuts-y",
          `${this.mouseY - rect.top + 20}px`,
        );
        this.rafPending = false;
        this.rafId = null;
      });
    }
  },
);
